import { Divider } from "@mui/material";
import { Component } from "react";
//import LODGE_DATA from "../../data/lodges-data.json";
import LodgeItem from "../lodge-item/lodge-item.component";
import "./lodge-list.styles.scss";
import React from 'react';

class LodgeList extends Component {
  constructor() {
    super();

    this.state = {
      lodges: [],
    };
  }

  componentDidMount() {
    // Dynamically import the JSON file
    import("../../data/lodges-data.json")
      .then((data) => {
        this.setState(
          {
            lodges: data.default, // Use `data.default` since dynamic imports load the default export
          },
          () => console.log("Lodges fetched and set:", data.default)
        );
      })
      .catch((error) => console.error("Error loading lodges data:", error));
  }

  render() {
    const { lodges } = this.state;
    console.log("ditrito seleccionado: " + this.props.district);
    return lodges
      .filter((lodge) => lodge.STATE_CODE === (this.props.district) || lodge.COUNTRY === (this.props.district))
      .map((filteredLodge) => {
        // console.log(lodge);
        const autoOpen =
          filteredLodge.DISTRICT_ID === this.props.autoOpenDistrictId &&
          filteredLodge.LODGE_ID === this.props.autoOpenLodgeId;
        return (
          <div key={filteredLodge.NUMB}>
            <LodgeItem lodge={filteredLodge} autoOpen={autoOpen} />
            <br></br>
            <Divider />
            <br></br>
          </div>
        );
      });
  }
}

export default LodgeList;
